<template>
  <AppLayoutContainer class="rich-text-block" v-if="visible">
    <AppAtomWhiteBlock>
      <AppRichText v-if="data.text" :data="data.text"/>
      <slot/>
    </AppAtomWhiteBlock>
  </AppLayoutContainer>
</template>

<script setup lang="ts">
/*
  Future Devs: if new fields are added to this collection
  this block should be split into an archive-blocks version and a regular version
 */
import {TRichTextBlock} from '~/types/block-types'
import {TArchiveRichTextBlock} from "~/types/block-archive-types";
import {computed} from "vue";
import {isVisible} from "~/utils/visibility";

const props = defineProps<{
  data: TRichTextBlock | TArchiveRichTextBlock,
}>()

const visible = computed(() => {
  return isVisible(props.data)
})

</script>
